import { AlertDialog } from '../../AlertDialog/AlertDialog';

export interface FinancialInstrumentConfirmModalProps {
  open: boolean;
  /** Título del diálogo. */
  title: string;
  /** Cuerpo / descripción. */
  body: string;
  /** Texto del botón de confirmación. */
  confirmLabel: string;
  /** Texto del botón de cancelar. */
  cancelLabel: string;
  /** Mutación en vuelo: bloquea botones y muestra spinner. */
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Modal de confirmación de borrado del Instrumento Financiero (105-17).
 *
 * Envuelve el `AlertDialog` del kit (variante `danger`); el borrado es lógico
 * (soft-delete) y libera el slot para capturar uno nuevo.
 */
export function FinancialInstrumentConfirmModal({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  isLoading,
  onConfirm,
  onClose,
}: FinancialInstrumentConfirmModalProps) {
  return (
    <AlertDialog
      isOpen={open}
      type="danger"
      title={title}
      description={body}
      cancelText={cancelLabel}
      confirmText={confirmLabel}
      isProcess={isLoading}
      preventCloseOnOverlayClick
      onCancel={onClose}
      onConfirm={onConfirm}
    />
  );
}
